<template>
  <v-form @submit="changePassword" id="reset_fields">
    <div class="flex layout-row pt-4" style="max-width: 700px;min-height:450px;">
      <ValidationObserver ref="RegisterFromTokenForm" v-slot="{ valid, pristine, reset }" class="layout-column flex" v-if="token && isNewUser">

        <div class="flex layout-column">

          <div class="px-8 pt-5 layout-column">
            <validation-provider tag="div" ref="Password" name="Password" rules="required" v-slot="{ errors }">
              <v-text-field
                v-model="model.password"
                :error-messages="errors[0]"
                color="white"
                dark
                outlined
                autofocus
                prepend-inner-icon="fingerprint"
                :label="$t('AUTH.NEW_PASSWORD.PASSWORD_1')"
                placeholder=" "
                :hint="$t('AUTH.NEW_PASSWORD.PASSWORD_1_HINT')"
                :clearable="false"
                :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                autocomplete="off"
              ></v-text-field>
            </validation-provider>
            <validation-provider tag="div" ref="Confirmation" name="Confirmation" rules="required|password:Password" v-slot="{ errors }">
              <v-text-field
                color="white"
                dark
                placeholder=" "
                outlined
                :error-messages="errors[0]"
                :label="$t('AUTH.NEW_PASSWORD.PASSWORD_2')"
                prepend-inner-icon="fingerprint"
                v-model="model.password2"
                :clearable="false"
                :append-icon="showPassword2 ? 'visibility' : 'visibility_off'"
                @click:append="showPassword2 = !showPassword2"
                :type="showPassword2 ? 'text' : 'password'"
                autocomplete="off"
              ></v-text-field>
            </validation-provider>
            <v-alert class="ma-0 elevation-3" color="blue-grey darken-1 white--text text--darken-2">{{ $t('AUTH.NEW_PASSWORD.PASSWORD_CREATION_HINT') }}</v-alert>
          </div>
        </div>

        <v-divider class="mx-5"></v-divider>

        <div class="pa-2 d-flex flex-row">
          <div class="grow mr-1">
            <div class="grow">
              <lx-btn class="mr-1 text-none"
                      type="submit"
                      color="green"
                      block
                      :disabled="!valid || pristine"
                      :label="$t('AUTH.NEW_PASSWORD.BUTTONS.SUBMIT')"
                      :tooltip="$t('AUTH.NEW_PASSWORD.BUTTONS.SUBMIT_HINT')"></lx-btn>
            </div>
          </div>
          <lx-btn class="mr-1 text-none"
                  @click="clearForm(reset)"
                  color="white"
                  :disabled="pristine"
                  icon="clear"
                  :tooltip="$t('AUTH.NEW_PASSWORD.BUTTONS.RESET_HINT')"></lx-btn>
        </div>
      </ValidationObserver>

    </div>

  </v-form>
</template>

<script>
import Vue from 'vue'
import router from '../../../router'

export default Vue.component('NewPasswordComponent', {
  props: {
    token: {
      type: String,
      default: function () {
        return false
      }
    },
  },
  data () {
    return {
      loading: false,
      model: {},
      showPassword: false,
      showPassword2: false,
      isNewUser: true
    }
  },
  created () {
    if (!this.token || (this.token.match(/^[0-9\-a-f]{36}$/i) === null)) {
      router.push({ path: '/auth/login' })
    } else {
      this.$http.get('checkGuid/' + this.token)
        .then(() => {})
        .catch(() => {
          router.push({ path: '/auth/login' })
        })
    }
  },
  methods: {
    changePassword (ev) {
      if (this.loading) return
      this.loading = true

      ev.preventDefault() // wichtig damit Formular mit Enter abgeschickt werden kann

      this.$http.post('/forgotPassword/confirm', { guid: this.token, password: this.model.password })
        .then(() => {
          this.loading = false
          router.push({ path: '/auth/login' })
        })
        .catch((error) => {
          if (error?.response?.status === 404) {
            this.NotifyError(this.$t('AUTH.FORGOT_PASSWORD.LINK_INVALID'))
            router.push({ path: '/auth/login' })
          } else {
            this.NotifyError(error)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    clearForm (reset) {
      reset()
      this.model = {}
    }
  }
})
</script>
